// This is generated.  Alter it in blockGroups/formElements/types/EditableList.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { merge } = require('lodash');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    const { id, title, propertyName, required } = hNode;

    // This block tells us nothing about namespaces/relations, but maybe the children do?
    let [subDataDictionary = {}, _partialTypeDefinition = {}] =
      hNode.children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // reuse consistent flags
    const { isOptional, schemaOptions } = moduleRegistration.resolveFieldFlags(
      required,
      context,
    );
    const maybeOptional = (schema) =>
      isOptional ? Type.Optional(schema) : schema;

    // Build the array schema with object items containing the child properties
    const itemSchema = Type.Object(_partialTypeDefinition, {
      title: 'Item',
      'x-dataType': 'object',
      additionalProperties: true,
    });

    const arraySchema = maybeOptional(
      Type.Array(itemSchema, {
        title: title,
        'x-id': id,
        'x-dataType': 'array',
        'x-propertyName': propertyName,
        ...schemaOptions,
      }),
    );

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: arraySchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'EditableList',
  module.exports,
);
